import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="sticky-navbar"
export default class extends Controller {
  handle() {
    let open = "sticky top-0 shadow-2xl ring-b ring-1 ring-gray-800/30".split(
      " ",
    );
    if (window.scrollY > 100) {
      this.element.classList.add(...open);
    } else {
      this.element.classList.remove(...open);
    }
  }
}
